// Dynamically loads any components based on page conditions

const pageHas = (selector) => {
  return document.querySelectorAll(selector).length
}

const loadComponents = async () => {
  if (pageHas('[data-counter]')) {
    const { default: component } = await import(
      /* webpackChunkName: "components-count-up" */ '@scripts/components/count-up'
    )

    component.init()
  }

  if (pageHas('[data-paginated-list]')) {
    const { default: component } = await import(
      /* webpackChunkName: "components-paginated-list" */ '@scripts/components/paginated-list'
    )

    component.init()
  }

  if (pageHas('[data-modal]')) {
    const { default: component } = await import(/* webpackChunkName: "components-modal" */ '@scripts/components/modal')

    component.init()
  }

  if (pageHas('[data-tablist]')) {
    const { default: component } = await import(
      /* webpackChunkName: "components-popover" */ '@scripts/components/tablist'
    )

    component.init()
  }

  if (pageHas('[data-popover]')) {
    const { default: component } = await import(
      /* webpackChunkName: "components-popover" */ '@scripts/components/popover'
    )

    component.init()
  }

  if (pageHas('[data-tooltip]')) {
    const { default: component } = await import(
      /* webpackChunkName: "components-tooltip" */ '@scripts/components/tooltip'
    )

    component.init()
  }

  if (pageHas('.media-slider')) {
    const { default: component } = await import(
      /* webpackChunkName: "components-page-header" */ '@scripts/components/media-slider'
    )

    component.init()
  }
}

export default {
  init: loadComponents,
}
